import App from 'App';
import 'i18n';
import 'regenerator-runtime/runtime';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import store from 'store';
import { injectStore } from 'services/api';
import { StyleSheetManager } from 'styled-components';
import { shouldForwardProp } from 'styles/shouldForwardProps';

injectStore(store);

const router = createBrowserRouter([{ path: '*', element: <App /> }]);

const container = document.getElementById('root');

if (container) {
    const root = ReactDOM.createRoot(container);

    root.render(
        <Provider store={store}>
            <StyleSheetManager shouldForwardProp={shouldForwardProp}>
                <RouterProvider router={router} />
            </StyleSheetManager>
        </Provider>,
    );
}
